module.exports = __webpack_public_path__ + "img/linkedin_new.3499917f.svg";